export const CREDIT_TYPES = ['CREDIT_CUSTOMER_SUPPORT','CREDIT_MARKETING'];

export const DEBIT_TYPES = ['DEBIT_BY_KIWI'];

export enum TRANSACTION_TYPES {
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT',
}

